import React, { useContext } from 'react';
import AuthContext from './AuthContext';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const { loginDetails, setLoginDetails } = useContext(AuthContext);
  if (!loginDetails.isAuthenticated) {
    return <Navigate to="/lessonplanner/" />;
  }
  return children;
};

export default PrivateRoute;
